const roundDate = (d: Date, resolution: number) => {
  const t = d.getTime()
  return t - (t % resolution)
}

// Default resolution is 1 day = 86400000ms
export const compareTimes = (d1: Date, d2: Date, resolution: number = 86400000) => {
  return roundDate(d1, resolution) === roundDate(d2, resolution)
}
